'use client';

import clientConfig from '../../client/config';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { usePage } from '../Providers/PageProvider';
import { useTranslation } from 'react-i18next';

export const StartFundraisingLink = () => {
  const { t } = useTranslation();
  const { event, charity, campaign } = usePage();
  const isPageOwner = useIsPageOwner();

  if (isPageOwner || !event || (event.endDate && event.endDate < new Date())) {
    return null;
  }

  const href = new URL(
    `${clientConfig.justGivingRootUrl}/create-page?eventId=${event.externalId}&charityId=${charity.externalId}`,
  );

  if (campaign) {
    href.searchParams.set('campaignId', campaign.id);
  }

  return (
    <a className="cp-text-link" href={href.toString()}>
      {t('event.startFundraising')}
    </a>
  );
};
